import React, { useState } from 'react';
import { Box, Typography, Grid, TextField, Chip } from '@mui/material';
import styled from '@emotion/styled';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Mail';
import { FileUpload } from '../../../components/FileUpload';
import { useAppSelector } from '../../../store/reduxHooks';
import { v4 as uuid } from 'uuid';
import config from '../../../assets/config';

const FormTopStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));

const FormImageLeftStyled = styled(Box)(({}) => ({
  width: 100,
  height: 100,
  borderRadius: 100,
  overflow: 'hidden',
  marginRight: 20,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
}));

const FromTestRightStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

const FormContactRowStyled = styled(Box)(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '20px',
}));

function ChangeReadOnly({ data }: any) {
  return (
    <>
      <Chip label={data.uuid} variant='outlined' />
      <FormTopStyled>
        <FormImageLeftStyled
          sx={{
            backgroundImage: data.uuid
              ? `url(${config.backendPath}/api/admin/v1/file/profile/${data.uuid})`
              : '',
          }}
        ></FormImageLeftStyled>
        <FromTestRightStyled>
          <Typography fontWeight={'bold'} fontSize={'1.5rem'}>
            {data.name}
          </Typography>
          <Typography>{data.title}</Typography>
        </FromTestRightStyled>
      </FormTopStyled>
      <FormContactRowStyled>
        <EmailIcon />
        <Typography key={`${data.id}-email`}>{data.email}</Typography>
      </FormContactRowStyled>
      <FormContactRowStyled>
        <PhoneIcon />
        <Typography key={`${data.id}-mobile`}>{data.mobile}</Typography>
      </FormContactRowStyled>
      <Typography variant='h5' color={'GrayText'}>
        About
      </Typography>
      <Typography>{data.about}</Typography>
    </>
  );
}

function ChangeEdit({ data, setPayload }: any) {
  const [imageKey, setImageKey] = useState<string>(
    'profile_picture' + data._id + uuid()
  );
  const { token } = useAppSelector((state) => state.auth);
  const onFieldEdit = (e: any) => {
    setPayload({
      ...data,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Chip label={data.uuid} variant='outlined' />
      </Grid>
      <Grid item xs={6}>
        <FormImageLeftStyled
          id={imageKey}
          key={imageKey}
          sx={{
            backgroundImage: data.uuid
              ? `url(${config.backendPath}/api/admin/v1/file/profile/${data.uuid}?q=${imageKey})`
              : '',
          }}
        />
        <FileUpload
          uploadUrl={`/api/admin/v1/file/upload/${data.uuid}`}
          token={token}
          onSuccess={() => {
            setImageKey('profile_picture' + data._id + uuid());
          }}
        />
      </Grid>
      <Grid item xs={6}></Grid>
      <Grid item xs={12}>
        <TextField
          label='Name'
          name='name'
          defaultValue={data.name}
          size={'small'}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='Title'
          name='title'
          defaultValue={data.title}
          size={'small'}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextField
          label='Mobile'
          name='mobile'
          size={'small'}
          defaultValue={data.mobile}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item sm={12} md={6}>
        <TextField
          label='Email'
          name='email'
          size={'small'}
          defaultValue={data.email}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label='About'
          name='about'
          multiline
          maxRows={10}
          defaultValue={data.about}
          size={'small'}
          onBlur={onFieldEdit}
          fullWidth={true}
        />
      </Grid>
    </Grid>
  );
}

export { ChangeReadOnly, ChangeEdit };
